import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { GetTherapistInvitationsArgs } from "../schemas/invitations";

export const GET_THERAPIST_INVITATIONS_QUERY_KEY = "getTherapistInvitations";

const getTherapistInvitationsQueryKey = (args: GetTherapistInvitationsArgs) =>
  [GET_THERAPIST_INVITATIONS_QUERY_KEY, args.params] as const;

export const useGetTherapistInvitations = (args: GetTherapistInvitationsArgs) => {
  const client = useApiClient();

  return useQuery(getTherapistInvitationsQueryKey(args), () => client.getTherapistInvitations(args));
};
